import { useEffect } from "react";
import { useLocalStorage } from "usehooks-ts";

export type Theme = "dark" | "light";

export const useTheme = () => {
  const defaultDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
  const [theme, setTheme] = useLocalStorage<Theme>(
    "theme",
    defaultDark ? "dark" : "light"
  );

  useEffect(() => {
    document.documentElement.classList[theme === "dark" ? "add" : "remove"](
      "dark"
    );
  }, []);

  function toggleTheme(): void {
    setTheme((theme) => {
      document.documentElement.classList[theme === "dark" ? "remove" : "add"](
        "dark"
      );
      return theme === "dark" ? "light" : "dark";
    });
  }

  const isDarkMode = theme === "dark";

  return { isDarkMode, toggleTheme };
};
